<template>
    <ion-card>
        <ion-card-header>
            <ion-card-title>{{ $t('ncrypt.profile_avatar.title') }}</ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <h2>{{ $t('ncrypt.profile_avatar.subtitle') }}</h2>

            <div style="display: flex; justify-content: center;">
                <img v-if="$store.getters.user && $store.getters.user.avatar_url"
                     class="avatar"
                     :src="$store.getters.user.avatar_url"
                     alt="profile picture"
                     style="max-width: 200px;"/>
                <div v-else style="margin-top: 20px; font-size: 80%;">{{ $t('ncrypt.profile_avatar.no_subtitle_yet') }}</div>
            </div>

            <div v-if="! changedProfile">
                <div v-if="! canUploadAvatar">
                    <ion-item color="danger"
                              style="width: 100%;">
                        {{ $t('ncrypt.profile_avatar.max_updates_reached') }}
                    </ion-item>
                </div>

                <ion-item lines="none" v-else>
                    <file-uploader
                        ref="fileUploader"
                        bucket="ncrypt-avatars"
                        :dropzoneOptions="dropzoneOptions"
                        :addFileText="$t('ncrypt.profile_avatar.select_photo')"
                    />
                </ion-item>

                <ion-item lines="none" style="margin-top: 20px;">
                    <ion-button :disabled="submitting || ! canUploadAvatar"
                                expand="block"
                                size="default"
                                shape="round"
                                style="margin: 0 auto;"
                                @click="processQueue">
                        {{ $t('ncrypt.profile_avatar.start_upload_button') }}
                    </ion-button>
                </ion-item>
            </div>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import FileUploader from "../FileUploader";
    import {Notifier} from "@/services/Notifier";

    export default {
        name: "ProfileAvatar",
        components: {FileUploader},
        data() {
            return {
                submitting: false,
                changedProfile: false,
                dropzoneOptions: {
                    acceptedFiles: 'image/*',
                },
            }
        },
        computed: {
            dropzoneOptions() {
                return {
                    maxFiles: 1,
                    maxFilesize: this.maxFileSize,
                }
            },
            maxFileSize() {
                return 10;
            },
            canUploadAvatar() {
                return this.$store.getters.user && this.$store.getters.user.can_upload_avatar;
            }
        },
        methods: {
            isValid() {
                return this.$refs.fileUploader.isValid();
            },
            async processQueue() {
                if (!this.$refs.fileUploader.dropzone.getQueuedFiles().length) {
                    await Notifier.showAlert({
                        message: this.$t('ncrypt.profile_avatar.select_photo_before_upload'),
                    });
                    return;
                }

                this.submitting = true;

                const finishedUrl = `${this.$store.getters.api_url}/avatar/uploaded`;

                await this.$refs.fileUploader.processQueue(finishedUrl, []);

                this.submitting = false;
                this.changedProfile = true;

                await Notifier.showToast({
                    message: this.$t('ncrypt.profile_avatar.update_successful'),
                });

                await this.$store.dispatch('refreshUser');
            },
        },
    }
</script>

<style lang="scss">
    #app {
        .dropzone.dz-started .dz-message {
            display: none;
        }
    }

    img.avatar {
        height: auto !important;
        align-self: flex-start;
    }
</style>
